import { render, staticRenderFns } from "./NoticeWrapper.vue?vue&type=template&id=68bcdd4e"
import script from "./NoticeWrapper.vue?vue&type=script&lang=js"
export * from "./NoticeWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports